import { createSlice } from "@reduxjs/toolkit";

const questionnaireResponseSlice = createSlice({
    name: "questionnaireResponses",
    initialState: {},
    reducers: {
        registerQuestionnaireResponse: (state, action) => {
            const response = action.payload;
            if (!response?.id) return;

            if (!state[response.id]) {
                state[response.id] = response;
            } else {
                console.warn(
                    `⚠️ QuestionnaireResponse ${response.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterQuestionnaireResponses: (state, action) => {
            action.payload.forEach((response) => {
                if (!response?.id) return;

                if (!state[response.id]) {
                    state[response.id] = response;
                } else {
                    console.warn(
                        `⚠️ QuestionnaireResponse ${response.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerQuestionnaireResponse,
    bulkRegisterQuestionnaireResponses
} = questionnaireResponseSlice.actions;

export default questionnaireResponseSlice.reducer;
